export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[620px] flex items-center pt-16 md:pt-18 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20amber%20and%20coral%20gradient%20lighting%2C%20abstract%20movie%20theater%20elements%2C%20soft%20bokeh%20lights%2C%20elegant%20modern%20entertainment%20backdrop%2C%20rich%20contrast%2C%20no%20text%2C%20dreamy%20atmospheric%20texture%2C%20cinematic%20color%20grade%20with%20teal%20shadows%20and%20warm%20highlights%2C%20wide%20screen%20composition&width=1920&height=1080&seq=hero-bg-2026-ql&orientation=landscape"
          alt="青柠影视背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs md:text-sm font-medium mb-4 md:mb-5 whitespace-nowrap border border-primary-500/25">
              海量影视 · 每日更新 · 永久免费
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl font-black text-white leading-tight mb-3 md:mb-4">
              青柠影视 - 免费高清在线追剧平台
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-white/80 font-medium mb-5 md:mb-6">
              不缓冲 · 不付费 · 不将就
            </p>

            <div className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl lg:max-w-none mb-6 md:mb-7 space-y-3">
              <p>
                青柠影视致力于为广大影迷提供海量高清影视资源的免费在线观看服务。平台覆盖热门电视剧、院线大片、经典老片、综艺动漫等全品类内容，每日同步更新最新剧集与电影资源。
              </p>
              <p>
                无论你是追剧达人还是电影爱好者，青柠影视都能满足你对高清画质和流畅播放的追求。无需下载、无需付费、无需注册，打开即看，让免费追剧看片变得前所未有的简单。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7 md:mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-black text-white">20000+</div>
                <div className="text-xs md:text-sm text-white/55">海量片库</div>
              </div>
              <div className="w-px h-8 md:h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-black text-white">每日更新</div>
                <div className="text-xs md:text-sm text-white/55">同步追剧</div>
              </div>
              <div className="w-px h-8 md:h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-black text-white">1080P</div>
                <div className="text-xs md:text-sm text-white/55">高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 md:gap-4">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-bold text-sm md:text-base transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline shadow-lg shadow-primary-500/25"
              >
                开始免费追剧
              </a>
              <a
                href="#about"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium text-sm md:text-base transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline border border-white/20"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end w-full">
            <div className="relative w-[280px] h-[380px] md:w-[360px] md:h-[480px] lg:w-[420px] lg:h-[540px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20composition%2C%20dramatic%20lighting%20with%20warm%20coral%20and%20amber%20accents%2C%20modern%20entertainment%20aesthetic%2C%20abstract%20film%20reels%20and%20play%20button%20elements%2C%20elegant%20dark%20background%20with%20glowing%20highlights%2C%20rich%20cinematic%20color%20palette%2C%20editorial%20quality%2C%20high%20detail%2C%20professional%20poster%20style%2C%20no%20visible%20text%20or%20logos&width=840&height=1080&seq=hero-visual-2026-ql&orientation=portrait"
                alt="青柠影视主视觉 - 海量高清影视免费观看"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary-500/40 cursor-pointer">
                  <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                </div>
                <div>
                  <div className="text-white text-xs md:text-sm font-bold">正在热播</div>
                  <div className="text-white/70 text-xs">点击开始追剧之旅</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}